import React, { useState, useEffect, useRef } from "react";
import style from "./HomepageModule.module.css";
import bookIcon from "../../../assests/homepageBook.png";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import progressImg from "../../../assests/progress.png";
import { baseurl } from "../../Url";
import { useNavigate, useOutletContext } from "react-router-dom";
import Loader from "../../Loder/Loader";
import { useSelector } from "react-redux";
import welcomeImage from "../../../assests/Group 34.png";
import { IoPlay } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import ActiveCalendar from "../../../assests/activeCalendar.png";
import ActiveWorkOut from "../../../assests/ActiveWeightlifting-sport-exercise-gym (1).png";
import TimerImage from "../../../assests/Chronometer.png";
import successImg from "../../../assests/Business Way to success.png";
import Calendar from "../../../assests/Calendar.png";
import WorkOut from "../../../assests/Weightlifting-sport-exercise-gym.png";
import EwImg from "../../../assests/EwImg.png";
import HappyImg from "../../../assests/happyImg.png";

const MODULE_THEMES = [
  {
    color: "#595BDB",
    gradient:
      "linear-gradient(180deg, rgba(6, 9, 160, 0.35) 0%, rgba(255, 255, 255, 0) 72%)",
  },
  {
    color: "#FF8800",
    gradient:
      "linear-gradient(180deg, rgba(255, 136, 0, 0.35) 0%, rgba(255, 255, 255, 0) 72%)",
  },
  {
    color: "#00CBF4",
    gradient:
      "linear-gradient(180deg, rgba(0, 203, 244, 0.35) 0%, rgba(255, 255, 255, 0) 72%)",
  },
];

const CountUp = ({ end = 0, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const target = Number(end) || 0;

    if (target === 0) {
      setCount(0);
      return;
    }

    let startTime = null;
    let animationFrame;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;

      const progress = Math.min((currentTime - startTime) / duration, 1);
      setCount(Math.floor(progress * target));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration]);

  return <>{count.toLocaleString()}</>;
};

const Homepage = () => {
  const { finished, setFinished } = useOutletContext();
  const carouselRef = useRef(null);
  const [overallProgress, setOverallProgress] = useState(0);
  const [moduleList, setModuleList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [dailYDrill, setDailyDrill] = useState(false);
  const [weeklyWorkout, setWeeklyWorkout] = useState(false);
  const [snoozePopup, setSnoozePopup] = useState(false);
  const [result, setResult] = useState({});
  const [activePopup, setActivePopup] = useState(null);
  const [videoPopup, setVideoPopup] = useState(false);
  const [sessionExpire, setSessionExpire] = useState(false);
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const subscribePopupOpenRef = useRef(false);
  const pendingDailyDrillRef = useRef(false);
  const [totalCount, setTotalCount] = useState({
    module_count: 0,
    topic_count: 0,
    skill_count: 0,
    qstn_count: 0,
  });
  const [categoryName, setCategoryName] = useState("GrammarLocker");
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);

  const userId = localStorage.getItem("USERID");
  const OrgId = localStorage.getItem("ORGID");
  const key = JSON.parse(localStorage.getItem("access-token"));

  const navigate = useNavigate();

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const currentDate = getCurrentDate();

  const handleSnooze = (minutes) => {
    if (activePopup === "dailyDrill") {
      snoozeCreate(minutes, "daily");
    } else if (activePopup === "weeklyWorkout") {
      snoozeCreate(minutes, "weekly");
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    const cookieConsent = localStorage.getItem("cookie-consent");
    localStorage.clear();
    if (cookieConsent !== null) {
      localStorage.setItem("cookie-consent", cookieConsent);
    }
    navigate("/login");
    window.location.reload();
  };

  // const getNotifications = async () => {
  //   try {
  //     const response = await fetch(`${baseurl}/check/user_notif`, {
  //       method: "GET",
  //     });
  //     if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
  //     const data = await response.json();
  //     console.log("📨 Notifications:", data);
  //   } catch (error) {
  //     console.error("❌ Error fetching notifications:", error);
  //   }
  // };

  const getTotalCount = async () => {
    try {
      const response = await fetch(
        `${baseurl}/organization/journey-summary_v2`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: OrgId,
          }),
        }
      );

      const data = await response.json();

      if (data.status) {
        setTotalCount(prev => ({
          ...prev,
          module_count: data.data.module_count,
          topic_count: data.data.topic_count,
          skill_count: data.data.skill_count,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getQuestionCount = async () => {
    try {
      const response = await fetch(
        `${baseurl}/organization/question-count`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: OrgId,
          }),
        }
      );

      const data = await response.json();

      if (data.status) {
        setTotalCount(prev => ({
          ...prev,
          qstn_count: data.data.qstn_count,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  async function getModuleTopicCount() {
    try {
      const res = await fetch(`${baseurl}/userlearning/module-topic-count`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails?.auth_token}`,
        },
      });
      const data = await res.json();
      if (data.status === true && data.data.length > 0) {
        localStorage.setItem("categoryID", data.data[0]?.category_id);
        setCategoryName(data.data[0]?.category_name);
      }
    } catch (error) {
      console.error("Error fetching module/topic count:", error);
    }
  }

  async function dailyWeeklyExam(Type) {
    const type = Type ? Type : "daily";
    await fetch(`${baseurl}/check/daily/weakly/exams`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgId,
        user_id: userId,
        date: currentDate,
        type: type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setResult(data.data[0]);

          if (
            Type &&
            Type === "daily" &&
            data.data[0]?.Daily_Drill?.DailyDrill === true &&
            data.data[0]?.Daily_Drill?.snoozed === false
          ) {
            queueOrShowDailyDrill();
          }
          if (
            Type &&
            Type === "weekly" &&
            data.data[0]?.WeeklyDrill?.WeeklyDrill === true &&
            data.data[0]?.WeeklyDrill?.snoozed === false
          ) {
            setWeeklyWorkout(true);
          }

          if (
            data.data[0]?.Daily_Drill?.DailyDrill === true &&
            data.data[0]?.Daily_Drill?.snoozed === false &&
            !JSON.parse(localStorage.getItem("hasShownDailyDrill")) &&
            localStorage.getItem("cookie-consent") === "accepted"
          ) {
            queueOrShowDailyDrill(true);
          }

          if (
            data.data[0]?.Daily_Drill?.DailyDrill === true &&
            data.data[0]?.Daily_Drill?.snoozed === false &&
            JSON.parse(localStorage.getItem("dailySnoozeTriggered"))
          ) {
            queueOrShowDailyDrill();
            localStorage.removeItem("dailySnoozeTriggered");
          }

          if (
            data.data[0]?.WeeklyDrill?.WeeklyDrill === true &&
            data.data[0]?.WeeklyDrill?.snoozed === false &&
            JSON.parse(localStorage.getItem("weeklySnoozeTriggered"))
          ) {
            setWeeklyWorkout(true);
            localStorage.removeItem("weeklySnoozeTriggered");
          }
        } else {
          if (
            data.description === "Token has expired" ||
            data.msg === "Token has expired"
          ) {
            setSessionExpire(true);
          }
        }
      });
  }

  async function snoozeCreate(min, type) {
    await fetch(`${baseurl}/snooze/create`, {
      method: "POST",
      body: JSON.stringify({
        org_id: userDetails && userDetails.org_id,
        user_id: userDetails && userDetails._id?.$oid,
        snooze_min: min.toString(),
        exam_type: type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setSnoozePopup(false);
          setActivePopup(null);
          dailyWeeklyExam();
          if (type === "daily") {
            localStorage.setItem("dailySnoozeTriggered", true);
          } else if (type === "weekly") {
            localStorage.setItem("weeklySnoozeTriggered", true);
          }
        }
      });
  }

  async function getOverallProgress() {
    try {
      const response = await fetch(`${baseurl}/user/overall_progress`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
        body: JSON.stringify({
          user_id: userId,
        }),
      });
      const data = await response.json();
      if (data.status === true) {
        setOverallProgress(data.data);
      }
    } catch (error) {
      console.error("Error fetching overall progress:", error);
    }
  }

  async function getModuleList() {
    try {
      const response = await fetch(`${baseurl}/user/module_list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
        body: JSON.stringify({
          user_id: userId,
          org_id: OrgId,
        }),
      });
      const data = await response.json();
      if (data.status === true) {
        setModuleList(data.data);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      console.error("Error fetching module list:", error);
    }
  }

  useEffect(() => {
    // getNotifications();
    getTotalCount();
    getQuestionCount();
  }, []);

  useEffect(() => {
    if (userId) {
      getOverallProgress();
      getModuleList();
    }
  }, [userId]);

  const isTrialUser = userDetails?.user_type === "Trail";

  const queueOrShowDailyDrill = (markAsShown = false) => {
    if (isTrialUser && subscribePopupOpenRef.current) {
      pendingDailyDrillRef.current = markAsShown ? "mark" : true;
      return;
    }
    setDailyDrill(true);
    if (markAsShown) {
      localStorage.setItem("hasShownDailyDrill", true);
    }
  };

  const closeSubscribePopup = ({ showPendingDrill = true } = {}) => {
    subscribePopupOpenRef.current = false;
    setShowSubscribePopup(false);
    if (!showPendingDrill || !pendingDailyDrillRef.current) return;
    const shouldMark = pendingDailyDrillRef.current === "mark";
    pendingDailyDrillRef.current = false;
    setDailyDrill(true);
    if (shouldMark) {
      localStorage.setItem("hasShownDailyDrill", true);
    }
  };

  useEffect(() => {
    if (userDetails) {
      getModuleTopicCount();
      if (
        userDetails.user_type === "Trail" &&
        !JSON.parse(localStorage.getItem("hasShownSubscribePopup"))
      ) {
        subscribePopupOpenRef.current = true;
        setShowSubscribePopup(true);
        localStorage.setItem("hasShownSubscribePopup", true);
      }
      dailyWeeklyExam();
    }
  }, [userDetails]);

  useEffect(() => {
    const interval = setInterval(() => {
      dailyWeeklyExam();
    }, 30000);
    return () => clearInterval(interval);
  }, [userDetails]);

  useEffect(() => {
    if (finished) {
      setFinished(false);
    }
  }, []);

  const handleScroll = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
      setShowLeftArrow(scrollLeft > 10);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      const timer = setTimeout(handleScroll, 100);
      carousel.addEventListener("scroll", handleScroll);
      return () => {
        clearTimeout(timer);
        carousel.removeEventListener("scroll", handleScroll);
      };
    }
  }, [moduleList]);

  const scrollCarousel = (direction = "right") => {
    if (carouselRef.current) {
      const card = carouselRef.current.querySelector(`.${style.moduleCard}`);
      const cardWidth = card ? card.offsetWidth : 257;
      const gap = 16;
      const scrollAmount = cardWidth + gap;
      
      if (direction === "left") {
        carouselRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else {
        carouselRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  const formatPercentage = (value) => {
    const percentage = Number(value) || 0;
    return Math.min(100, Math.max(0, Math.round(percentage)));
  };

  return (
    <div className={style.container}>
      {loading ? <Loader /> : ""}
      <div className={style.dashboardSection}>
        <div className={style.welcomeSection}>
          <div className={style.welcomeSectionLeft}>
            <p>
              Hello{" "}
              {userStatus === "succeeded" &&
                userDetails &&
                userDetails.FirstName}
              !
            </p>
            {userDetails && userDetails.user_type === "Trail" ? (
              <span>Welcome to your free GrammarLocker trial!</span>
            ) : (
              <span>Welcome to {categoryName}</span>
            )}
          </div>
          <div className={style.welcomeSectionRight}>
            <div className={style.welcomeImageContainer}>
              <div className={style.welcomeImage}>
                <img src={welcomeImage} alt="welcome" />
              </div>
            </div>
          </div>
        </div>
        
        <div className={style.activitySection}>
          <div className={style.activitySectionContainerLeft}>
            <div className={style.wrapper}>
              {overallProgress?.has_progress === false ? (
                <div className={style.adventureCard}>
                  <div className={style.adventureLeft}>
                    <h2 className={style.adventureTitle}>
                      Your Grammar adventure begins now!
                    </h2>
                    <p className={style.adventureSubtitle}>
                      Complete topics, conquer daily drills, tackle weekly workouts and collect badges as you level up your English skills.
                    </p>
                    <button
                      type="button"
                      className={style.viewModuleBtn}
                      onClick={() => navigate("/new/learnings")}
                    >
                      View Module 1
                    </button>
                  </div>
                  <div className={style.adventureRight}>
                    <div className={style.adventureIllustration}>
                      <img src={HappyImg} alt="Grammar adventure illustration" />
                    </div>
                  </div>
                </div>
              ) : (
                <div className={style.progressCard}>
                  <div className={style.progressLeft}>
                    <h2 className={style.progressTitle}>Overall progress</h2>
                    <p className={style.progressSubtitle}>
                      You have completed {formatPercentage(overallProgress?.percentage)} % of GrammarLocker
                    </p>

                    <div className={style.chartLegendRow}>
                      <div
                        className={style.donutChart}
                        style={{
                          background: `conic-gradient(#595BDB ${formatPercentage(overallProgress?.percentage) * 3.6}deg, #E8E8EC 0)`,
                        }}
                      >
                        <span className={style.chartPercent}>{formatPercentage(overallProgress?.percentage)}%</span>
                      </div>

                      <div className={style.legend}>
                        <div className={style.legendItem}>
                          <span
                            className={style.legendDot}
                            style={{ background: "#595BDB" }}
                          />
                          <div>
                            <p className={style.legendLabel}>Completed</p>
                            <p className={style.legendSub}>{overallProgress?.completed_count || 0} modules</p>
                          </div>
                        </div>
                        <div className={style.legendItem}>
                          <span
                            className={style.legendDot}
                            style={{ background: "#FF8800" }}
                          />
                          <div>
                            <p className={style.legendLabel}>In progress</p>
                            <p className={style.legendSub}>{overallProgress?.inprogress_count || 0} modules</p>
                          </div>
                        </div>
                        <div className={style.legendItem}>
                          <span
                            className={style.legendDot}
                            style={{ background: "#D9D9D9" }}
                          />
                          <div>
                            <p className={style.legendLabel}>Not started</p>
                            <p className={style.legendSub}>{overallProgress?.not_started || 0} modules</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={style.progressDivider} />

                  <div className={style.progressRight}>
                    <div className={style.progressRightText}>
                      <h3>Keep going {userStatus === "succeeded" &&
                  userDetails &&
                  userDetails.FirstName}!</h3>
                      <p>
                        Continue your learning journey and keep up with scores to earn
                        Xp&apos;s
                      </p>
                      <button type="button" className={style.viewProgressBtn} onClick={() => navigate("/performance")}>
                        View detailed progress
                      </button>
                    </div>
                    <div className={style.progressIllustration}>
                      <img src={progressImg} alt="Learning progress" />
                    </div>
                  </div>
                </div>
              )}

              <div className={style.modulesSection}>
                <div className={style.modulesHeader}>
                  <h2>Modules</h2>
                  <button type="button" className={style.viewAllLink} onClick={() => navigate("/new/learnings")}>
                    View all modules
                  </button>
                </div>

                <div className={style.modulesCarouselWrap}>
                  <div className={style.modulesCarousel} ref={carouselRef}>
                    {moduleList.map((mod, index) => {
                      const theme = MODULE_THEMES[index % MODULE_THEMES.length];

                      return (
                        <div
                          key={mod.title}
                          className={style.moduleCard}
                          style={{ borderColor: theme.color }}
                        >
                          <div
                            className={style.moduleCardHeader}
                            style={{ background: theme.gradient }}
                          >
                            <span className={style.moduleNumber}>
                              {String(index + 1).padStart(2, "0")}
                            </span>
                            <div
                              className={style.moduleBookIcon}
                              style={{ background: theme.color }}
                            >
                              <img src={bookIcon} alt="" />
                            </div>
                          </div>

                          <div className={style.moduleCardBody}>
                            <h4 className={style.moduleTitle}>{mod.module_name}</h4>

                            <div className={style.moduleStats}>
                              <span>{mod.topic_count} topics</span>
                              <div className={style.moduleProgressTrack}>
                                <div
                                  className={style.moduleProgressFill}
                                  style={{
                                    width: `${mod.percentage}%`,
                                    background: theme.color,
                                  }}
                                />
                              </div>
                              <span>{formatPercentage(mod.percentage)}%</span>
                            </div>

                            <button
                              type="button"
                              className={style.continueBtn}
                              style={{ background: theme.color }}
                              onClick={() =>
                                navigate("/new/learnings", {
                                  state: {
                                    returnFromLearnOrSkill: true,
                                    scrollToModuleIndex: index,
                                    expandedModuleIndices: [index],
                                    targetModuleId: mod.module_id || mod.id || mod._id,
                                    targetModuleName: mod.module_name,
                                    initialSkillsTab: "all-skills",
                                  },
                                })
                              }
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {showLeftArrow && (
                    <button
                      type="button"
                      className={`${style.carouselArrow} ${style.arrowLeft}`}
                      onClick={() => scrollCarousel("left")}
                      aria-label="Scroll left"
                    >
                      <IoIosArrowBack />
                    </button>
                  )}

                  {showRightArrow && (
                    <button
                      type="button"
                      className={`${style.carouselArrow} ${style.arrowRight}`}
                      onClick={() => scrollCarousel("right")}
                      aria-label="Scroll right"
                    >
                      <IoIosArrowForward />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <div className={style.activitySectionRight}>
            <div className={style.encouragementCard}>
              <div className={style.encouragementLeft}>
                <div className={style.encouragementText}>
                  <span><FaCheck className={style.TickMark}/> {totalCount.module_count || 0} Modules</span>
                  <span><FaCheck className={style.TickMark}/> {totalCount.topic_count || 0} Topics</span>
                  <span><FaCheck className={style.TickMark}/> {totalCount.skill_count || 0} Skills</span>
                  <span><FaCheck className={style.TickMark}/> <CountUp end={totalCount.qstn_count} duration={2000}/> Questions</span>
                </div>
              </div>
              <div className={style.encouragementRight}>
                <img src={successImg} alt="success illustration" />
              </div>
            </div>
            <p className={style.rightSectionHeader}>How it works</p>
            <div
              className={style.videoCardBanner}
              style={{ backgroundImage: `url(${EwImg})` }}
            >
              <h4 className={style.videoCardTitle}>Your {categoryName} Journey</h4>
              <button
                onClick={() => setVideoPopup(true)}
                className={style.watchNowBtn}
              >
                <IoPlay /> <p>Watch Now</p>
              </button>
            </div>
            
            <p className={style.rightSectionHeader}>Test, test, test!</p>
            

            <div
              onClick={() => {
                dailyWeeklyExam("daily");
              }}
              className={`${style.activityCard} ${
                result?.Daily_Drill?.DailyDrill === false ||
                result?.Daily_Drill?.snoozed === true
                  ? style.disabledCard
                  : style.dailyCard
              }`}
            >
              <div className={style.activityCardImage}>
                {result?.Daily_Drill?.DailyDrill === false ||
                result?.Daily_Drill?.snoozed === true ? (
                  <img src={Calendar} alt="calendar" />
                ) : (
                  <img src={ActiveCalendar} alt="calendar" />
                )}
              </div>
              <div className={style.activityCardText}>
                <p>Daily drill</p>
              </div>
            </div>
            <div
              className={`${style.activityCard} ${
                result?.WeeklyDrill?.WeeklyDrill === false ||
                result?.WeeklyDrill?.snoozed === true
                  ? style.disabledCard
                  : style.weeklyCard
              }`}
              onClick={() => {
                dailyWeeklyExam("weekly");
              }}
            >
              <div className={style.activityCardImage}>
                {result?.WeeklyDrill?.WeeklyDrill === false ||
                result?.WeeklyDrill?.snoozed === true ? (
                  <img src={WorkOut} alt="workout" />
                ) : (
                  <img src={ActiveWorkOut} alt="workout" />
                )}
              </div>
              <div className={style.activityCardText}>
                <p>Weekly workout</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      {dailYDrill && !showSubscribePopup ? (
        <>
          <div
            className={style.popupOverlay}
            onClick={() => {
              setDailyDrill(false);
            }}
          ></div>
          <div className={style.Popup}>
            <div className={style.popupHeader}>
              <div className={style.popupHeaderIcon}>
                <img src={ActiveCalendar} alt="calendar" />
              </div>
              <div className={style.popupMainHeader}>
                <p>Daily Drill</p>
              </div>
              <div className={style.popupSubHeader}>
                <p>
                  Sharpen your skills daily with quick, focused exercises.
                  <br />
                  Practice makes perfect!
                </p>
              </div>
            </div>
            <div className={style.popupBody}>
              <div className={style.popupBodyTop}>
                <div className={style.popupBodyCard}>
                  <span>{result?.Daily_Drill?.no_of_questions}</span>
                  <p>Questions</p>
                </div>
                <div className={style.popupBodyCard}>
                  <img src={TimerImage} alt="timer" />
                  <p>{result?.Daily_Drill?.alloted_time} mins</p>
                </div>
              </div>
              <div className={style.popupBodyBottom}>
                <p>Are you ready to take the daily drill?</p>
              </div>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.snoozeButton}
                onClick={() => {
                  setDailyDrill(false);
                  setActivePopup("dailyDrill");
                  setSnoozePopup(true);
                }}
              >
                Snooze
              </button>
              <button
                className={style.yesButton}
                onClick={() => {
                  navigate("/daily/drill");
                  window.location.reload();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {weeklyWorkout ? (
        <>
          <div
            className={style.popupOverlay}
            onClick={() => {
              setWeeklyWorkout(false);
            }}
          ></div>
          <div className={style.PopupWeekly}>
            <div className={style.popupHeader}>
              <div className={style.popupHeaderIcon}>
                <img src={ActiveWorkOut} alt="calendar" />
              </div>
              <div className={style.popupMainHeaderWeekly}>
                <p>Weekly Workout</p>
              </div>
              <div className={style.popupSubHeader}>
                <p>
                  It's that time of the week again - do your weekly workout
                  <br />
                  and keep those skills tip-top!
                </p>
              </div>
            </div>
            <div className={style.popupBody}>
              <div className={style.popupBodyTop}>
                <div className={style.popupBodyCard}>
                  <span>{result?.WeeklyDrill?.no_of_questions}</span>
                  <p>Questions</p>
                </div>
                <div className={style.popupBodyCard}>
                  <img src={TimerImage} alt="timer" />
                  <p>{result?.WeeklyDrill?.alloted_time} mins</p>
                </div>
              </div>
              <div className={style.popupBodyBottom}>
                <p>Are you ready to take the weekly workout?</p>
              </div>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.snoozeButton}
                onClick={() => {
                  setWeeklyWorkout(false);
                  setActivePopup("weeklyWorkout");
                  setSnoozePopup(true);
                }}
              >
                Snooze
              </button>
              <button
                style={{ background: "#00DFC7" }}
                className={style.yesButton}
                onClick={() => {
                  navigate("/weekly/workout");
                  window.location.reload();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {snoozePopup ? (
        <>
          <div
            className={style.popupOverlay}
            onClick={() => {
              setSnoozePopup(false);
              setActivePopup(null);
            }}
          ></div>
          <div className={style.Popup}>
            <div className={style.snoozeHeader}>
              <p>
                When should we remind you for the{" "}
                {activePopup === "dailyDrill"
                  ? "Daily Drill"
                  : "Weekly Workout"}
                ?
              </p>
            </div>
            <div className={style.snoozeContainer}>
              <div
                onClick={() => handleSnooze(10)}
                className={style.snoozeCard}
              >
                <p>In 10 min</p>
              </div>
              <div
                onClick={() => handleSnooze(30)}
                className={style.snoozeCard}
              >
                <p>In 30 min</p>
              </div>
              <div
                onClick={() => handleSnooze(60)}
                className={style.snoozeCard}
              >
                <p>In 60 min</p>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {videoPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.videoPopup}>
            <div className={style.videoContainer}>
              <div className={style.videoClose}>
                <AiOutlineClose onClick={() => setVideoPopup(false)} />
              </div>
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/ahPJndSMICQ?autoplay=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </>
      )}

      {sessionExpire ? (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.expirePopup}>
            <div className={style.expirePopupText}>
              <p>Your session expired please login again</p>
            </div>
            <div className={style.expirePopupButton}>
              <button
                className={style.yesButton}
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout(e);
                }}
              >
                Login
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {showSubscribePopup ? (
        <>
          <div
            className={style.popupOverlay}
            onClick={() => {
              closeSubscribePopup();
            }}
          ></div>
          <div className={style.Popup}>
            <div className={style.popupHeader}>
              <div className={style.popupHeaderIcon}>
                <img src={EwImg} alt="subscribe" style={{ width: '80px', height: '80px' }} />
              </div>
              <div className={style.popupMainHeader}>
                <p>Subscribe Now</p>
              </div>
              <div className={style.popupSubHeader}>
                <p>
                  Unlock unlimited access to all GrammarLocker modules, topics, and exercises!
                </p>
              </div>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.subCancelBtn}
                onClick={() => {
                  closeSubscribePopup();
                }}
              >
                Close
              </button>
              <button
                className={style.subButton}
                onClick={() => {
                  closeSubscribePopup({ showPendingDrill: false });
                  navigate("/subscribe");
                }}
              >
                Subscribe
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Homepage;
